<template>
  <div id="page-404">
    <div ref="starsBg" id="starsBg"></div>
    <div id="notFound">
      <h1 v-text="title"></h1>
      <p v-text="message"></p>
      <mu-raised-button id="goBackBtn" label="Go Back" @click.native="goBack()"></mu-raised-button>
    </div>
  </div>
</template>
<script>
  import "gsap";
  export default {
    data () {
      return {
        title: '404',
        message: 'The page you were looking for seems to have gone missing'
      }
    },
    mounted () {
      let self = this;
      function stars() {
        let tl = new TimelineMax({
          repeat: -1
        });
        tl.to(self.$refs['starsBg'], 100, {
          backgroundPosition: "-2247px bottom",
          force3D: true,
          rotation: 90,
          z: 0.5,
          ease: Linear.easeNone
        });
        return tl;
      }
      let TimeLine = new TimelineMax({
        repeat: -1
      });
      TimeLine
        .add(stars(), 0)
        .timeScale(0.7)
        .progress(1).progress(0)
        .play();
    },
    methods: {
      goBack() {
        let self = this;
        self.$router.push({
          name: "Dashboard"
        })
      }
    }
  }
</script>
<style lang="less">
  @import url('./404.less');
</style>



// WEBPACK FOOTER //
// 404.vue?2d87c65a